var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowMenu('menu:system_settings'))?_c('system-index'):_c('tenant-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }